import classNames from "classnames";
import React from "react";
import { CSS_CLASSES } from "./progress-indicator-css-classes";
import { ProgressIndicatorLabelProps } from "./progress-indicator.types";

export const ProgressIndicatorLabel: React.FunctionComponent<ProgressIndicatorLabelProps> = ({
  label,
  labelPlacement,
  size,
  color,
}) => {
  const labelClassName = classNames(CSS_CLASSES.PROGRESS_INDICATOR_LABEL, {
    [CSS_CLASSES.PROGRESS_INDICATOR_LABEL_PLACEMENT_TOP_LABEL]: labelPlacement === "top",
    [CSS_CLASSES.PROGRESS_INDICATOR_LABEL_PLACEMENT_RIGHT_LABEL]: labelPlacement === "right",
    [CSS_CLASSES.PROGRESS_INDICATOR_LABEL_PLACEMENT_BOTTOM_LABEL]: labelPlacement === "bottom",
    [CSS_CLASSES.PROGRESS_INDICATOR_LABEL_PLACEMENT_LEFT_LABEL]: labelPlacement === "left",
    [CSS_CLASSES.PROGRESS_INDICATOR_SMALL_LABEL]: size === "small",
    [CSS_CLASSES.PROGRESS_INDICATOR_MEDIUM_LABEL]: size === "medium",
    [CSS_CLASSES.PROGRESS_INDICATOR_LARGE_LABEL]: size === "large",
    [CSS_CLASSES.PROGRESS_INDICATOR_WHITE_LABEL]: color === "white",
  });

  return <span className={labelClassName}>{label}</span>;
};
